module.exports = __webpack_public_path__ + "static/media/error.9dc4fb89.png";